export const MONDAY = {
  label: 'lundi',
  value: 1,
}
export const TUESDAY = {
  label: 'mardi',
  value: 2,
}
export const WEDNESDAY = {
  label: 'mercredi',
  value: 3,
}
export const THURSDAY = {
  label: 'jeudi',
  value: 4,
}
export const FRIDAY = {
  label: 'vendredi',
  value: 5,
}
export const SATURDAY = {
  label: 'samedi',
  value: 6,
}
export const SUNDAY = {
  label: 'dimanche',
  value: 7,
}

export const WeekDays = [
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
  SUNDAY,
]



// WEBPACK FOOTER //
// ./src/constants/weekDays.ts